import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import LoginModal from 'src/components/LoginModal';
import useLogin from 'src/hooks/useLogin';
import { showModalAtom } from 'src/stores/modal/atoms';
import { EventLoginModalVisitorTrigger } from 'src/types/Event';
import { ModalType } from 'src/types/Modal';
type Props = {
  trigger?: EventLoginModalVisitorTrigger;
  executeOnLogin?: boolean;
};
export default function useCallbackWithCheckLogin<T extends (...args: any[]) => any>(callback: T, {
  trigger,
  executeOnLogin
}: Props = {
  executeOnLogin: true
}) {
  const {
    isLogin
  } = useLogin();
  const showModal = useSetAtom(showModalAtom);
  return useCallback((...args: Parameters<typeof callback>) => {
    if (!isLogin) {
      showModal({
        key: ModalType.LOGIN,
        component: () => <LoginModal {...executeOnLogin && {
          loginSuccessCallback() {
            return callback(...args);
          }
        }} trigger={trigger} />
      });
      return;
    }
    return callback(...args);
  }, [callback, executeOnLogin, isLogin, showModal, trigger]);
}